import { render, staticRenderFns } from "./RuleBack.vue?vue&type=template&id=740c130a&"
import script from "./RuleBack.vue?vue&type=script&lang=js&"
export * from "./RuleBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports